<template>
  <div
    :class="['programmirovanie-card', {
      'programmirovanie-card--tutor': card.direction === 'all',
    }]"
  >
    <img
      :src="`/v2/catalog/programmirovanie/catalog/${card.image}${isTablet ? '-mob' : ''}.webp`"
      :alt="card.title"
      class="programmirovanie-card__image"
    >

    <div class="programmirovanie-card__info">
      <p class="programmirovanie-card__title">
        <span>
          <span v-html="card.title" />
        </span>
        <b>{{ card.for }}</b>
      </p>

      <div class="programmirovanie-card__cheap">
        <span
          v-for="(cheap, index) in card.cheap"
          :key="index"
          :class="{ 'programmirovanie-card__cheap--colored': cheap.colored }"
        >
          {{ cheap.text }}
        </span>
      </div>

      <img
        src="/v2/catalog/repetitor/catalog/ya-split.svg"
        alt="split"
        class="programmirovanie-card__split"
      >
      <p class="programmirovanie-card__price">
        <b>{{ card.price | prettyCurrency(false) }}</b>
        <span>₽ за курс</span>
      </p>
    </div>

    <div class="programmirovanie-card__list">
      <div
        v-if="isLaptop ? showList : true"
        class="programmirovanie-card__list_modal"
        @click="showList = false"
      >
        <div class="programmirovanie-card__list_inner">
          <img
            src="/v2/catalog/repetitor/close.svg"
            alt="x"
            class="laptop"
          >

          <!-- eslint-disable max-len,vue/max-len -->
          <ul>
            <li
              v-for="(item, index) in card.textItems"
              :key="index"
              :class="{ 'programmirovanie-card__list--consult': card.additionConsult && index === 4 }"
              v-html="item"
            />
          </ul>
          <!-- eslint-enable -->

          <button
            class="m-btn laptop"
            @click="$emit('open-modal')"
          >
            Записаться
          </button>
        </div>
      </div>

      <img
        src="/v2/catalog/repetitor/catalog/info.svg"
        alt="i"
        class="laptop programmirovanie-card__list_i"
        @click="showList = true"
      >

      <button
        class="m-btn"
        @click="$emit('open-modal')"
      >
        Записаться
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProgrammirovanieCatalogCard',
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showList: false,
  }),
  computed: {
    ...mapGetters({
      isLaptop: 'isLaptop',
      isTablet: 'isTablet',
    }),
  },
};
</script>

<style scoped lang="scss">

.programmirovanie-card {
  padding: 20px 105px 20px 20px;
  display: flex;
  position: relative;
  filter: drop-shadow(4px 4px 20px rgba(7, 21, 57, 0.05)) drop-shadow(10px 10px 50px rgba(7, 21, 57, 0.1));
  background-image: url("/v2/catalog/programmirovanie/catalog/bg.svg");
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  overflow: hidden;

  @include media-down(desktop) {
    padding-right: 10px;
  }

  @include media-down(laptop) {
    padding: 8px;
    display: grid;
    grid-template-columns: 275px 1fr;
    row-gap: 10px;
    column-gap: 20px;
  }

  @include media-down(tablet) {
    padding-bottom: 20px;
    grid-template-columns: 100%;
    justify-items: center;

    background-image: url("/v2/catalog/programmirovanie/catalog/bg-mob.svg");
    background-position: right top;
  }

  &::before {
    @include media-down(tablet) {
      content: '';
      position: absolute;
      width: 200px;
      height: 200px;
      right: -108px;
      bottom: -178px;

      background-color: #67ADFF;
      filter: blur(200px);
    }
   }

  &__image {
    width: 275px;
    height: 280px;
    box-shadow: inset 8px 8px 30px rgba(87, 106, 135, 0.02), inset 2px 2px 10px rgba(87, 106, 135, 0.02);
    border-radius: 10px;

    @include media-down(laptop) {
      grid-row: 1/3;
    }

    @include media-down(tablet) {
      height: auto;
      width: min(100%, 550px);
    }
  }

  &__info  {
    display: flex;
    flex-direction: column;
    margin-left: 20px;

    @include media-down(laptop) {
      margin-left: 0;
      margin-right: auto;
      max-width: 550px;
    }
  }

  &__title {
    width: fit-content;
    position: relative;
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 110%;
    letter-spacing: -0.01em;
    text-transform: uppercase;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $white-color;

    //@include media-down(tablet) {
    //  color: $black;
    //}

    & > span {
      position: relative;
      display: block;
      width: fit-content;

      span {
        position: relative;
        z-index: 2;
      }

      &:before {
        content: '';
        position: absolute;
        width: calc(100% + 11px);
        height: 29px;
        left: -7px;
        top: -2px;
        background-color: #4A88DA;

        @include media-down(tablet) {
          width: calc(100% + 10px);
          left: -6px;
        }
      }
    }

    b {
      display: block;
      color: $black;
    }
  }

  &__cheap {
    max-width: 302px;
    margin-top: 20px;
    margin-bottom: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    @include media-down(laptop) {
      max-width: 100%;
      margin-top: 12px;
    }

    @include media-down(tablet) {
      margin-bottom: 24px;
    }

    span {
      padding: 9px 15px 11px;
      background-color: #EFF3F7;
      border-radius: 50px;

      font-weight: 500;
      font-size: 16px;
      line-height: 100%;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $black;

      &.programmirovanie-card__cheap--colored {
        color: #4A88DA;
      }
    }
  }

  &__split {
    width: 86px;
    margin-bottom: 3px;
  }

  &__price {
    b {
      font-weight: 700;
      font-size: 32px;
      line-height: 100%;
      letter-spacing: -0.02em;
      text-transform: uppercase;
      font-feature-settings: 'case' on;
      color: $black;
    }

    span {
      font-weight: 500;
      font-size: 16px;
      line-height: 90%;
      letter-spacing: -0.02em;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $black;
    }
  }

  &__list {
    margin-top: 4px;
    margin-left: auto;
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include media-down(desktop) {
      width: 350px;
    }

    @include media-down(laptop) {
      width: 100%;
    }

    @include media-down(tablet) {
      margin-left: 0;
      max-width: 550px;
    }

    .programmirovanie-card__list_modal {
      @include media-down(laptop) {
        position: fixed;
        inset: 0;
        z-index: 50;
        display: grid;
        place-items: center;

        &:before {
          content: '';
          position: absolute;
          inset: 0;
          background-color: rgba(36, 36, 36, 0.3);
          backdrop-filter: blur(3.5px);
        }
      }
    }

    .programmirovanie-card__list_inner {
      @include media-down(laptop) {
        position: relative;
        display: grid;
        gap: 32px;
        width: min(344px, calc(100% - 16px));
        padding: 40px 16px 16px;

        background-color: $white-color;
        box-shadow: 10px 10px 22px rgba(7, 21, 57, 0.1), 4px 4px 14px rgba(7, 21, 57, 0.05);
        border-radius: 20px;

        img {
          position: absolute;
          right: 0;
          top: 0;
        }
      }

      button {
        padding: 14px 10px 16px;
        border: none;
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 12px;

      li {
        position: relative;
        display: flex;

        font-weight: 500;
        font-size: 16px;
        line-height: 130%;
        letter-spacing: -0.01em;
        font-feature-settings: 'pnum' on, 'lnum' on;
        color: $black;

        &::before {
          content: '';
          position: relative;
          left: -2px;
          flex-shrink: 0;
          display: block;
          width: 16px;
          height: 19px;
          background-image: url("/v2/catalog/repetitor/catalog/check.svg");
          background-repeat: no-repeat;
        }

        &.programmirovanie-card__list--consult {
          font-weight: 800;

          &::before {
            background-image: url("/v2/catalog/repetitor/catalog/plus.svg");
          }
        }
      }
    }

    button {
      margin-top: auto;
      padding: 13px 57px;
      background-color: #FA5019;
      border: 2px solid $brown-dark;
      border-radius: 30px;
      transition: 200ms;

      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: $white-color;

      &:hover {
        box-shadow: 0 4px 0 $brown-dark;
        transform: translateY(-4px);
      }

      @include media-down(tablet) {
        width: min(100%, 550px);
      }
    }

    &_i {
      position: absolute;
      right: 8px;
      bottom: 95px;
    }
  }

  &.programmirovanie-card--tutor {
    @include media-up(tablet) {
      background-image: url("/v2/catalog/programmirovanie/catalog/bg-tutor.svg");
    }

    &::before {
      background-color: #9579DA;
    }

    .programmirovanie-card__title span:before {
      background-color: #9579DA;
    }
  }
}

</style>
